import React from 'react';
import classNames from 'classnames';

const Theme = (props) => {
  if (!props.Content) return props.children;

  const theme = classNames({
    'theme--faq':
      props.Content.Theme === 'faq' || props.PageTypeName === 'FaqPage',
    'theme--story':
      props.Content.Theme === 'story' || props.PageTypeName === 'StoryPage',
    'theme--pod':
      props.Content.Theme === 'podcast' || props.PageTypeName === 'PodcastPage',
    'theme--forum':
      props.Content.Theme === 'forum' || props.PageTypeName === 'ForumPage',
  });

  const themeClass = classNames(
    {
      'theme--is-theme': theme.length > 0,
    },
    theme
  );

  return theme.length > 0 ? (
    <div className={themeClass}>
      <div className="theme__icon"></div>
      {props.children}
    </div>
  ) : (
    props.children
  );
};

export default Theme;
